import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IUtil_GetAllRepoClocResponse  } from './util.model';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  private endpoint = "util";

  constructor(private apiService: ApiService) { }

   getGetAllRepoCloc() {
    return this.apiService.get<IUtil_GetAllRepoClocResponse>({
      Url: `${this.endpoint}/repo-cloc/cloc-lang/all`,
    });
  }

  getGetAllRepoClocPaged(pageNumber: number, pageSize: number) {
    const params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());
    return this.apiService.getAllPageed<IUtil_GetAllRepoClocResponse>({
      Url: `${this.endpoint}/repo-cloc/paged/all`,
      Params: params
    });
  }

  getGetAllRepoClocId(id: number) {
    return this.apiService.get<IUtil_GetAllRepoClocResponse>({
      Url: `${this.endpoint}/${id}`,
    });
  }

  createClocRepo(body: any) {
    // return this.apiService.post<ICompany_Request, ICompany_Response>({
    //   Url: `${this.endpoint}/contact-us`,
    //   Body: body
    // });
  }

  updateClocRepo(jobId: number, job: any) {
    // return this.apiService.put<object, ICompany_Response>({
    //   Url: `${this.endpoint}/${jobId}`,
    //   Body: job
    // });
  }

  deleteClocRepo(id: number) {
    // return this.apiService.delete<object, object>({
    //   Url: `${this.endpoint}/${id}`,
    //   Body: {}
    // });
  }
}
